import { render, staticRenderFns } from "./CustomerSubjectAreas.vue?vue&type=template&id=afbd8264"
import script from "./CustomerSubjectAreas.vue?vue&type=script&lang=js"
export * from "./CustomerSubjectAreas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports